enum ForecastViewMode {
  MONTH = "month",
  QUARTER = "quarter",
}

export default ForecastViewMode;
